import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    document.querySelectorAll('.search-result-count-update').forEach(el => {
      el.textContent = this.element.textContent
    })
  }
}
